var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as cn from "classnames";
import * as moment from "moment";
import * as React from "react";
import * as styles from "./styles.css";
import Ad from "backpack-ui/dist/components/ad";
import CalloutLink from "backpack-ui/dist/components/calloutLink";
import Container from "backpack-ui/dist/components/container";
import GridColumn from "backpack-ui/dist/components/gridColumn";
import GridRow from "backpack-ui/dist/components/gridRow";
import TabbedNav from "backpack-ui/dist/components/tabbedNav";
import NewsList from "../newsList";
import { getImgixUrl } from "../../utils/getImgixUrl";
import { slugify } from "../../utils/slugify";
var TabbedCategories = /** @class */ (function (_super) {
    __extends(TabbedCategories, _super);
    function TabbedCategories(props) {
        var _this = _super.call(this, props) || this;
        // Category Names
        var tabTitles = [
            "Behind the scenes",
            "Community",
            "Pathfinders",
            "Quizzes and Competitions",
            "Wonderings",
        ];
        // Default First Category Articles
        var tabArticles = _this.props.catBehindTheScenes;
        _this.state = {
            activeCat: "Behind the scenes",
            tabArticles: tabArticles,
            tabTitles: tabTitles,
            tabbedCalloutLink: "/blog/category/behind-the-scenes",
        };
        _this.changeTabbedArticles = _this.changeTabbedArticles.bind(_this);
        return _this;
    }
    TabbedCategories.prototype.changeTabbedArticles = function (event) {
        var button = event.target;
        var catName = button.textContent || button.innerText;
        var catNameSlug = slugify(catName);
        var activeCatPosts;
        if (catName === "Behind the scenes") {
            activeCatPosts = this.props.catBehindTheScenes;
        }
        else if (catName === "Community") {
            activeCatPosts = this.props.catCommunity;
            catNameSlug = "lp-community";
        }
        else if (catName === "Pathfinders") {
            activeCatPosts = this.props.catPathfinders;
            catNameSlug = "lp-pathfinders";
        }
        else if (catName === "Quizzes and Competitions") {
            activeCatPosts = this.props.catQuizCompetitions;
        }
        else if (catName === "Wonderings") {
            activeCatPosts = this.props.catWonderings;
        }
        if (catName !== this.state.activeCat) {
            this.setState({
                activeCat: catName,
            });
            this.setState({
                tabArticles: activeCatPosts,
            });
            this.setState({
                tabbedCalloutLink: catNameSlug === "behind-the-scenes"
                    ? "/blog/category/behind-the-scenes"
                    : "/blog/category/" + catNameSlug,
            });
        }
    };
    TabbedCategories.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(Container, null,
                React.createElement(GridRow, { className: cn("TabbedNavRow", styles.tabbedNavRow) },
                    React.createElement(GridColumn, { sm: 12, fluid: true },
                        React.createElement(TabbedNav, { active: this.state.activeCat, items: this.state.tabTitles, onClick: function (e) {
                                _this.changeTabbedArticles(e);
                            } }))),
                React.createElement(GridRow, null,
                    React.createElement(GridColumn, { className: styles.marginTop, sm: 12, md: 6, lg: 6, fluid: true },
                        React.createElement("div", { className: "TabbedArticles" },
                            React.createElement(NewsList, { newsItems: this.state.tabArticles.map(function (post) { return ({
                                    category: _this.state.activeCat,
                                    categoryLink: _this.state.tabbedCalloutLink,
                                    link: "/blog/" + moment(post.publicationDate).format("YYYY/MM/DD") + ("/" + post.metadata.slug),
                                    thumbnail: getImgixUrl(post.featuredImage ?
                                        post.featuredImage.url + "?auto=format&fit=crop&w=110&h=110&q=72" :
                                        // tslint:disable-next-line:max-line-length
                                        "https://lonelyplanetstatic.imgix.net/marketing/global/blog_comingsoon.jpg?fit=crop&w=110&h=110&q=72"),
                                    title: post.title,
                                }); }) }),
                            React.createElement(CalloutLink, { href: this.state.tabbedCalloutLink }, "More blog posts"))),
                    React.createElement(GridColumn, { className: styles.marginTop, sm: 12, md: 4, mdShift: 2, lg: 4, lgShift: 1, includeGutter: true, fluid: true },
                        React.createElement(Ad, { className: "FrontpageAdRail", id: "ad-home-right-rail", framed: true }))))));
    };
    return TabbedCategories;
}(React.Component));
export { TabbedCategories };



//////////////////
// WEBPACK FOOTER
// ./app/modules/blog/components/tabbedCategories/index.tsx
// module id = h5pz
// module chunks = 3